/**
 * Formats a number with comma separators for thousands
 * @param value - The number to format (can be null or undefined)
 * @returns A formatted number string with commas (e.g., "1,234,567") or "—" for null/undefined values
 * @example
 * formatNumber(1234567) // "1,234,567"
 * formatNumber(1000) // "1,000"
 * formatNumber(null) // "—"
 */
export function formatNumber(value: number | null | undefined): string {
  if (value === undefined || value === null) return "—";
  return new Intl.NumberFormat("en-US").format(value);
}
